var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIcPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#919191",
  stroke: "#919191",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M16 22H7.429A1.433 1.433 0 0 1 6 20.571V3.43C6 2.643 6.643 2 7.429 2H16c.786 0 1.429.643 1.429 1.429V20.57c0 .786-.643 1.429-1.429 1.429Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#454545",
  stroke: "#454545",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M17.429 4.857H6v12.857h11.429V4.857Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#DDD",
  stroke: "#DDD",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M11.714 21.285a.714.714 0 1 0 0-1.428.714.714 0 0 0 0 1.428Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#454545",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M10.286 2.714h2.857"
})));
export default SvgIcPhone;